import {ReactNode} from 'react';
import {View} from 'react-native';
import styles from '../styles/Styles';
import React from 'react';

interface ColProps {
  children: ReactNode;
  style?: any;
}

interface RowProps {
  children: ReactNode;
  style?: any;
}

export const Col: React.FC<ColProps> = ({children, style}) => (
  <View style={[styles.col, style]}>{children}</View>
);

export const Row: React.FC<RowProps> = ({children, style}) => (
  <View style={[styles.row, style]}>{children}</View>
);

